var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaosun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    width: 20,
    height: 20,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M890.9 215.8c-3.2-3.2-7-4.8-11.4-4.8h-202v-43c0-11-3.8-20.3-11.3-28.2-7.6-7.8-16.8-11.7-27.5-11.7H385.3c-10.7 0-19.9 3.9-27.5 11.7-7.6 7.8-11.3 17.2-11.3 28.2v43h-202c-4.4 0-8.2 1.7-11.4 5-3.2 3.3-4.9 7.3-5.1 11.9l20.4 160.9c0 4.6 1.6 8.6 4.8 12 3.2 3.3 7.1 5 11.7 5h39.5l24.5 456.5c0 9.4 3.3 17.4 9.8 24 6.4 6.6 14.2 9.8 23.3 9.8h500c9.2 0 17-3.3 23.4-10 6.4-6.7 9.6-14.7 9.6-24.1l24.5-456.5h39.6c4.4 0 8.2-1.6 11.4-4.8 3.2-3.2 4.9-7.1 5.1-11.7v-0.9L896 227.4c-0.2-4.5-1.9-8.4-5.1-11.6M368.8 476.6c-6.4-7.5-9.2-16-8.4-25.5 0.8-9.5 5-17.4 12.6-23.7 8.6-7 18.7-10 30.5-9 11.6 1 20.9 5.6 27.9 13.7l80.2 93.7 83.3-97.1c6.7-7.9 15.3-12.1 25.9-12.8 10.5-0.6 19.7 2.6 27.5 9.7l3.8 3.4c6.7 6.2 10.4 13.8 11.1 23 0.7 9.2-1.9 17.1-7.7 23.8l-93.8 108.6L655 693.5c7.2 8.5 9.8 17.9 7.9 28.2C661 732 655 740 645 745.8c-8.8 5.1-18.4 6.8-28.8 5.1-10.3-1.8-18.7-6.4-25.3-13.9l-79-93.3-80.2 93.7c-7.7 8.8-17.3 13.6-28.9 14.2-11.6 0.7-21.8-3-30.7-10.8l-0.4-0.3c-6.7-6.2-10.4-13.8-11.1-23-0.7-9.2 1.9-17.1 7.6-23.8l93.3-109.1-92.7-108z",
    "p-id": 6176,
    fill: "rgba(102,102,102,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaosun);
export default __webpack_public_path__ + "static/media/baosun.89e6fb24.svg";
export { ForwardRef as ReactComponent };